/**
 * @generated SignedSource<<12faf7105d38437c254265a4bf74e1ed>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type stripeConnectorPage_ExportMutation$variables = Record<PropertyKey, never>;
export type stripeConnectorPage_ExportMutation$data = {
  readonly stripeExportStart: {
    readonly dir: string | null | undefined;
    readonly enqueued: boolean;
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
  } | null | undefined;
};
export type stripeConnectorPage_ExportMutation = {
  response: stripeConnectorPage_ExportMutation$data;
  variables: stripeConnectorPage_ExportMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "enqueued",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dir",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "stripeConnectorPage_ExportMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StripeExportStartMutationPayload",
        "kind": "LinkedField",
        "name": "stripeExportStart",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "stripeConnectorPage_ExportMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StripeExportStartMutationPayload",
        "kind": "LinkedField",
        "name": "stripeExportStart",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "26d0483fae8358c1257f09aff8e8cd6f",
    "id": null,
    "metadata": {},
    "name": "stripeConnectorPage_ExportMutation",
    "operationKind": "mutation",
    "text": "mutation stripeConnectorPage_ExportMutation {\n  stripeExportStart {\n    enqueued\n    dir\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a36a6cf7171c25d55e49f03ad1a8157d";

export default node;
